import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/back-top.png';
const _withScopeId = n => (_pushScopeId("data-v-f0ab0dc8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "back-top",
  src: _imports_0,
  alt: ""
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_header = _resolveComponent("top-header");
  const _component_LayoutHeader = _resolveComponent("LayoutHeader");
  const _component_router_view = _resolveComponent("router-view");
  const _component_LayoutContent = _resolveComponent("LayoutContent");
  const _component_a_back_top = _resolveComponent("a-back-top");
  const _component_bottom_footer = _resolveComponent("bottom-footer");
  const _component_LayoutFooter = _resolveComponent("LayoutFooter");
  const _component_Layout = _resolveComponent("Layout");
  return _openBlock(), _createBlock(_component_Layout, {
    class: "mobile-layout-container"
  }, {
    default: _withCtx(() => [_createVNode(_component_LayoutHeader, {
      class: "layout-header"
    }, {
      default: _withCtx(() => [_createVNode(_component_top_header)]),
      _: 1
    }), _createVNode(_component_LayoutContent, {
      class: "layout-content"
    }, {
      default: _withCtx(() => [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          mode: "out-in",
          name: "fade"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
          _: 2
        }, 1024)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_a_back_top, null, {
      default: _withCtx(() => [_hoisted_1]),
      _: 1
    }), _createVNode(_component_LayoutFooter, {
      id: "footer_content",
      class: "layout-footer"
    }, {
      default: _withCtx(() => [_createVNode(_component_bottom_footer)]),
      _: 1
    })]),
    _: 1
  });
}